import React from "react";
import Grid from "@mui/material/Grid2";
import ModelFormControl from "./ModelFormControl";
import StyleFormControl from "./StyleFormControl";
import PersonaFormControl from "./PersonaFormControl";
import ToneFormControl from "./ToneFormControl";
import BasePromptFormControl from "./BasePromptFormControl";
import AudienceFormControl from "./AudienceFormControl";
import ExcludeFormControl from "./ExcludeFormControl";
import IncludeFormControl from "./IncludeFormControl";
import TemperatureFormControl from "./TemperatureFormControl";
import LengthFormControl from "./LengthFormControl";
import VariableFormControl from "./VariableFormControl";

import { RootState } from "../../app/store";
import { useAppSelector } from "../../app/hooks";
import { getVariablesKeys, mergeVariables } from "../../app/utils";

function ConfigurationPanel() {
  const variables = useAppSelector(
    (state: RootState) => state.prompts.selectedPrompt.variables
  );

  const basePrompt = useAppSelector(
    (state: RootState) => state.prompts.selectedPrompt.basePrompt
  );

  const newVariablesKeys = getVariablesKeys(basePrompt);
  const newVariables = mergeVariables(variables, newVariablesKeys);

  return (
    <Grid container spacing={3}>
      <Grid size={12}>
        <BasePromptFormControl />
      </Grid>
      {newVariables &&
        Object.keys(newVariables).map((variableName: string) => (
          <Grid key={variableName + "-container"} size={{ xs: 12, md: 12 }}>
            <VariableFormControl variableName={variableName} />
          </Grid>
        ))}
      <Grid size={{ xs: 12, md: 4 }}>
        <PersonaFormControl />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <StyleFormControl />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <AudienceFormControl />
      </Grid>
      <Grid size={{ xs: 12, md: 12 }}>
        <ToneFormControl />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <IncludeFormControl />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <ExcludeFormControl />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <ModelFormControl />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <TemperatureFormControl />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <LengthFormControl />
      </Grid>
    </Grid>
  );
}

export default ConfigurationPanel;
